export default "__VITE_ASSET__CihBsXvH__"